/* Timing (seconds) — exported so the /dev/motion playground tunes the real values. */
export const TIMING = {
  morph: 0.35, // expand/collapse scale + corner morph
  spinIdle: 5, // seconds per revolution at rest
  spinPlaying: 2.5, // seconds per revolution while the preview plays
}

/* The disc itself */
export const CD_CONFIG = {
  expandedScale: 1.12, // size when expanded
  hoverScaleIdle: 1.08, // hover lift while spinning
  hoverScaleExpanded: 1.16, // hover lift while expanded
  edgeInset: 5, // px the resting disc peeks above its frame
  smallSize: 200, // below this px, keep the disc fully visible (no y-offset)
}
